import * as DOMPurify from 'dompurify';

export interface DOMPurifyConfig extends DOMPurify.Config {
    RETURN_DOM_FRAGMENT?: false | undefined;
    RETURN_DOM?: false | undefined;
}

export enum SanitizeConfig {
    /**
     * Allow all safe HTML elements but neither SVG nor MathML
     * Glue elements like style, script or others to document.body and prevent unintuitive browser behavior in several edge-cases
     */
    HtmlForceBody = 'htmlForceBody',
    /**
     * Allow tag ['a'] with limited attributes ['style', 'class', 'target', 'href'].
     */
    AllowLinks = 'allowLinks',
}

export const config: Record<SanitizeConfig, DOMPurifyConfig> = {
    [SanitizeConfig.HtmlForceBody]: { USE_PROFILES: { html: true }, FORCE_BODY: true },
    [SanitizeConfig.AllowLinks]: {
        ALLOWED_TAGS: ['a'],
        ALLOWED_ATTR: ['style', 'class', 'target', 'href'],
    },
};

// This hook is to guard against reverse tabnabbing.
// See: https://owasp.org/www-project-web-security-testing-guide/latest/4-Web_Application_Security_Testing/11-Client-side_Testing/14-Testing_for_Reverse_Tabnabbing
DOMPurify.addHook('afterSanitizeAttributes', node => {
    const target = node.hasAttribute?.('target');

    if (target) {
        node.setAttribute('rel', 'noopener noreferrer');
    }

    return node;
});

export const sanitize = (source: string | Node, sanitizeConfig: SanitizeConfig): string => {
    return DOMPurify.sanitize(source, config[sanitizeConfig]);
};
